// 检测并打开Enjoy app的工具函数
export const openEnjoyApp = () => {
  const itmsUrl = 'itms-apps://apps.apple.com/app/id6468901311';
  // 仅使用 itms-apps 协议直接打开 App Store
  window.location.href = itmsUrl;
};

// 检测app是否已安装（更精确的方法）
export const checkAppInstalled = () => {
  return new Promise((resolve) => {
    const startTime = Date.now();
    let appOpened = false;

    // 尝试打开app
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = 'enjoy://';
    document.body.appendChild(iframe);

    // 监听页面可见性变化
    const handleVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
        resolve(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // 设置超时
    setTimeout(() => {
      document.body.removeChild(iframe);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      
      if (!appOpened) {
        resolve(false);
      }
    }, 1500);
  });
};
